import { Component, Input } from '@angular/core';
import { PanelChevronComponent } from '../../../UI-Lib/Weissman-Panel/panel.chevron.component';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AccrualsModule } from '../../../Accruals/accruals.module';


@Component({
    selector: 'accruals-panel',
    templateUrl: './accrualsPanel.component.html',
    imports: [PanelChevronComponent, TabsModule, AccrualsModule],
})
export class AccrualsPanelComponent {
    constructor() {}

    @Input() parcelId: number;
    @Input() hasEditPermission: boolean;

    showBody: boolean = false;
    showBalance: boolean = false;
    adjustmentsEditMode: boolean = false;

    expandOrCollapse(): void {
        this.showBody = !this.showBody;
    }
}
